import { useLanguage } from '../LanguageContext';
import translations from '../translations';
import './AboutPage.css';

function AboutPage({ onBack }) {
  const { language } = useLanguage();
  const t = translations[language];
  const a = t.about;

  return (
    <div className="about-page">
      <div className="about-page__inner">
        <button className="about-page__back" onClick={onBack} aria-label="Back">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="15 18 9 12 15 6" />
          </svg>
        </button>

        <h1 className="about-page__title">{a.title}</h1>
        <p className="about-page__subtitle">{a.subtitle}</p>

        <div className="about-page__section">
          <p className="about-page__quote">"{a.quote}"</p>
        </div>

        <div className="about-page__section">
          <h2 className="about-page__heading">{a.whyHeading}</h2>
          <p>{a.whyBody}</p>
        </div>

        <div className="about-page__section">
          <h2 className="about-page__heading">{a.whatHeading}</h2>
          <p>{a.whatBody}</p>
        </div>

        <div className="about-page__section">
          <h2 className="about-page__heading">{a.whoHeading}</h2>
          <p>{a.whoBody}</p>
        </div>

        <div className="about-page__section">
          <h2 className="about-page__heading">{a.hopeHeading}</h2>
          <p>{a.hopeBody}</p>
        </div>

        <div className="about-page__footer">
          <span>— Szilvia</span>
        </div>
      </div>
    </div>
  );
}

export default AboutPage;
